<script setup lang="ts">
import PremiumPhonesPage from "@/components/premium/PremiumPhonesPage.vue";
</script>

<template>
  <PremiumPhonesPage />
</template>

<style scoped lang="scss"></style>
